module.exports = __webpack_public_path__ + "media/images/flags/MV-c85ecf9cc48f753da77d0065aa4f83fb.svg";